import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as OffersActions from './../actions/offers.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, switchMap } from 'rxjs/operators';
import { TechnicalError } from '@dch/products-business-logic';
import { OffersService } from '../../services/offers.service';
import { IOffer } from '@proximus/common-business-logic';

@Injectable({
  providedIn: 'root',
})
export class OffersEffects {
  offers$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(OffersActions.GET_COPPER_OUT_PHASING_OFFER),
      switchMap(() =>
        this.offersService.getCopperOutPhasingOffer().pipe(
          map(
            (offer: IOffer) =>
              new OffersActions.GetCopperOutPhasingOfferSuccess(offer),
          ),
          catchError((error: IEntity<TechnicalError>) =>
            of(
              new OffersActions.GetCopperOutPhasingOfferFailed(
                error.errorData as TechnicalError,
              ),
            ),
          ),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private offersService: OffersService,
  ) {}
}
